export function IsTouchCapable() {
    const hasTouchEvents = "ontouchstart" in window;
    const hasTouchConstructor = typeof window !== "undefined" && "DocumentTouch" in window && document instanceof window.DocumentTouch;
    const hasTouchPoints = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    return hasTouchEvents || hasTouchConstructor || hasTouchPoints;
}
export var TouchGestureType;
(function (TouchGestureType) {
    TouchGestureType[TouchGestureType["Tap"] = 0] = "Tap";
    TouchGestureType[TouchGestureType["LongPress"] = 1] = "LongPress";
    TouchGestureType[TouchGestureType["Rotate"] = 2] = "Rotate";
    TouchGestureType[TouchGestureType["Swipe"] = 3] = "Swipe";
    TouchGestureType[TouchGestureType["Pinch"] = 4] = "Pinch";
    TouchGestureType[TouchGestureType["Drag"] = 5] = "Drag";
})(TouchGestureType || (TouchGestureType = {}));
//# sourceMappingURL=map.inputs.interfaces.touch.js.map